

define(['squid/index', 'text!./template.html', 'components/xo-models/src/checkout/index'], function (squid, template) {
    squid.module('xo-cart.cart-wrapper.directive', ['squid', 'xomodel.checkout']).directive('cartWrapper', function () {
        return {
            template: template,
            restrict: 'E',
            scope: {
                showAmt: '=',
                showArrow: '=',
                token: '='
            },
            controller: function controller($scope, $populate, $util, $CheckoutCartModel) {

                $util.assert($scope.token, 'Expected token');

                $populate($scope, {
                    checkoutCart: $CheckoutCartModel.instance($scope.token)
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/cart/cartWrapper/directive.js
// module id = ./components/xo-page-components/src/cart/cartWrapper/directive.js
// module chunks = 1